import React from "react";
import { Container } from "react-bootstrap";
import { FaGreaterThan } from "react-icons/fa";
import first from "../../../Asset/ai/1.png";
import second from "../../../Asset/ai/2.png";
import third from "../../../Asset/ai/3.png";
import fourth from "../../../Asset/ai/4.png";
import fifth from "../../../Asset/ai/5.png";
import "./Seventh.css";

const StepCard = ({ imageSrc, title, steps }) => {
  return (
    <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
      <div className="d-flex flex-column g-4">
        <div className="img-container mb-3">
          <img src={imageSrc} alt={title} className="w-100" />
        </div>
        <div className="text-container">
          <h3 className="h3 mb-3">{title}</h3>
          <ul className="elementor-icon-list-items">
            {steps.map((step, index) => (
              <li key={index} className="elementor-icon-list-item">
                <span>
                  <FaGreaterThan />
                </span>
                <span>{step}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Seventh = () => {
  const steps = [
    {
      imageSrc: first,
      title: "Understanding Business Goals & AI Needs",
      steps: [
        "Conduct in-depth stakeholder interviews",
        "Analyze current processes and pain points",
        "Identify key performance indicators (KPIs) for AI impact",
      ],
    },
    {
      imageSrc: second,
      title: "Tailored Solution Design",
      steps: [
        "Develop a customized AI strategy",
        "Select appropriate technologies and frameworks",
        "Create project roadmap and timeline",
      ],
    },
    {
      imageSrc: third,
      title: "Model Development",
      steps: [
        "Collect and process relevant data",
        "Build and train AI models using advanced algorithms",
        "Optimize models",
      ],
    },
    {
      imageSrc: fourth,
      title: "Testing and Deployment",
      steps: [
        "Perform quality assurance and performance testing",
        "Real-time monitoring and rapid issue resolution",
        "Security and compliance validation",
      ],
    },
    {
      imageSrc: fifth,
      title: "Training & Ongoing Support",
      steps: [
        "Provide comprehensive training sessions for your team",
        `Allot a dedicated "Account Manager" to resolve issues faster`,
        "Continuously monitor, update, and improve the AI solution",
      ],
    },
  ];

  return (
    <section className="nineth-d2c-section seventh-ai-section">
      <Container>
        <div className="text_wrap">
          <h2>
            Expert Team & <strong> Collaborative Approach</strong>
          </h2>
          <p className="store-success-intro">
            We work closely with your team to understand your goals and ensure
            our solutions align perfectly with your business objectives. Our
            5-Step Approach ensures a smooth transition to AI-driven operations,
            maximizing ROI and fostering long-term success.
          </p>
        </div>
        <div className="bottom-part row">
          {steps.map((stepData, index) => (
            <StepCard
              key={index}
              imageSrc={stepData.imageSrc}
              title={stepData.title}
              steps={stepData.steps}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Seventh;
